import { t } from "@/i18n-js/instance";
import { CHART_TYPES } from "@/react/hooks/analytics/chartTypes";
import { Typography } from "@circle-react-uikit/Typography";
import { ChartContainer } from "../ChartContainer";

interface EmptyStateProps {
  chartTitle: string;
  className?: string;
  emptyDescription?: string;
  emptyTitle?: string;
  tooltip?: string;
}

export const EmptyState = ({
  chartTitle,
  emptyTitle,
  emptyDescription,
  className,
  tooltip,
}: EmptyStateProps) => {
  const displayEmptyTitle =
    emptyTitle ?? t("analytics.shared.empty_state.title");
  const displayEmptyDescription =
    emptyDescription ?? t("analytics.shared.empty_state.description");

  return (
    <ChartContainer
      title={chartTitle}
      tooltip={tooltip}
      className={className}
      data={[]}
      chartType={CHART_TYPES.TABLE}
    >
      <div className="flex h-80 w-full flex-col items-center justify-center gap-2 text-center">
        <Typography.TitleMd>{displayEmptyTitle}</Typography.TitleMd>
        <Typography.BodyMd color="text-lighter">
          {displayEmptyDescription}
        </Typography.BodyMd>
      </div>
    </ChartContainer>
  );
};

EmptyState.displayName = "EmptyState";
